module.exports = __webpack_public_path__ + "static/acoustic-duo-profile-6d2443e74fb97b07bc0e19e21b47c0cb.jpg";